<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="人员" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="职位" min-width="100" prop="zhiwei"></el-table-column>
          <el-table-column align="center" label="工资明细" min-width="1500">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.detailList" :key="index">
                <span>{{item.kehu}}_{{item.dingdanhao}}_{{item.huohao}}_{{item.chanpinguige}}_{{item.yanse}}_{{item.xuhao}}</span>
                <span style="margin: 0 30px;">{{item.wuliaomingcheng}}_{{item.wuliaoguige}}_{{item.caizhi}}</span>
                <span style="margin-right: 30px;">装框工价：{{item.zhixingzhuangkuang}}</span>
                <span style="margin-right: 30px;">淋洗工价：{{item.zhixinglinxi}}</span>
                <span style="margin-right: 30px;">组焊件淋洗产量：{{item.chanliangzuhanjian}}</span>
                <span style="margin-right: 30px;">小件淋洗产量：{{item.chanliangxiaojian}}</span>
                <span>折算工资：{{item.gongzi}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="当日工资" min-width="100" prop="total_gongzi"></el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
const editFormData = () => {
  return {
    riqi: '',
    renyuan: "",
    zhiwei: "",
    gongzi: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      today: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      axios.post(this.$host+'/index.php/admin/Gongziexcel/tzlxgzbExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '涂装淋洗工资日报表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    getList() {
      this.listLoading = true
      let data = {
        // page: this.pageNum,
        // num: this.pageSize,
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      this.$request.post('/index.php/admin/Gongzibiao/tzlxgzb', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
